const e = {
  name: "ArrowRight",
  dimensions: { width: 20, height: 16 },
  content: `
        <path fill-rule="evenodd" clip-rule="evenodd" d="M11.2929 14.2929C10.9024 14.6834 10.9024 15.3166 11.2929 15.7071C11.6834 16.0976 12.3166 16.0976 12.7071 15.7071L19.7071 8.70711C19.8992 8.51499 19.9968 8.26416 19.9999 8.01237C20 8.00826 20 8.00413 20 8C20 7.9959 20 7.99181 19.9999 7.98773C19.9983 7.85661 19.9715 7.73156 19.9241 7.61722C19.8753 7.49927 19.803 7.38877 19.7071 7.29289L12.7071 0.292894C12.3166 -0.0976312 11.6834 -0.0976312 11.2929 0.292894C10.9024 0.683417 10.9024 1.31658 11.2929 1.70711L16.5858 7L1 7C0.447716 7 2.41411e-08 7.44771 0 8C-2.41412e-08 8.55228 0.447716 9 1 9L16.5858 9L11.2929 14.2929Z" fill="currentColor"/>
  `
};
export {
  e as ArrowRight
};
